import { render } from "./manage.vue?vue&type=template&id=4a15f94b&scoped=true"
import script from "./manage.vue?vue&type=script&lang=js"
export * from "./manage.vue?vue&type=script&lang=js"

import "./manage.vue?vue&type=style&index=0&id=4a15f94b&lang=less&scoped=true"
import "./manage.vue?vue&type=style&index=1&id=4a15f94b&lang=less&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a15f94b"]])

export default __exports__